import * as Sentry from "@sentry/react";

Sentry.init({
  dsn:
    window.__ENV__.VITE_SENSORS_FRONTEND_SENTRY_DSN ??
    import.meta.env.VITE_SENSORS_FRONTEND_SENTRY_DSN,
  sendDefaultPii: true,
  environment: window.__ENV__.VITE_MODE ?? import.meta.env.VITE_MODE ?? "local",
  initialScope: {
    tags: {
      app: "sensors-frontend",
      host: window.location.hostname,
    },
  },
});


